import { jsx, jsxs } from "@ecopages/jsx/jsx-runtime";
import { cx } from "@/lib/cx";
import "./radio-group.script";
export function RuiRadioGroupControl({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    "data-radio-group-root": true,
    class: cx("rui-radio-group", className),
    role: "radiogroup",
    "data-rui-control": true,
    "data-rui-control-type": "text",
    children
  });
}
export function RuiRadio({
  children,
  value,
  name,
  disabled,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsxs("label", {
    ...props,
    class: cx("rui-radio", className),
    children: [/* @__PURE__ */jsx("input", {
      type: "radio",
      class: "rui-radio__input",
      value,
      name,
      disabled,
      "data-disabled": disabled ? "" : void 0
    }), /* @__PURE__ */jsx("span", {
      class: "rui-radio__control",
      "aria-hidden": "true"
    }), /* @__PURE__ */jsx("span", {
      class: "rui-radio__label",
      children
    })]
  });
}
export function RuiRadioGroup({
  options,
  children,
  ...props
}) {
  return /* @__PURE__ */jsx("rui-radio-group", {
    ...props,
    children: options == null ? children : /* @__PURE__ */jsx(RuiRadioGroupControl, {
      children: options.map(option => /* @__PURE__ */jsx(RuiRadio, {
        value: option.value,
        disabled: option.disabled,
        children: option.label
      }))
    })
  });
}